/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Keywords_MetricsInputs */

const en_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3,000+ brands supported`)
};

const ar_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم أكثر من 3,000 علامة تجارية`)
};

const bn_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`৩,০০০+ ব্র্যান্ড সাপোর্টেড`)
};

const de_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über 3.000 Marken werden unterstützt`)
};

const es_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 3000 marcas admitidas`)
};

const fr_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de 3 000 marques prises en charge`)
};

const pt_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 3.000 marcas suportadas`)
};

const zh_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 3,000 多个品牌`)
};

const tr_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.000'den fazla marka destekleniyor`)
};

const ru_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживается более 3000 брендов`)
};

const pl_experience_keywords_metrics = /** @type {(inputs: Experience_Keywords_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługiwanych ponad 3000 marek`)
};

/**
* | output |
* | --- |
* | "3,000+ brands supported" |
*
* @param {Experience_Keywords_MetricsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_keywords_metrics = /** @type {((inputs?: Experience_Keywords_MetricsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Keywords_MetricsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_keywords_metrics(inputs)
	if (locale === "bn") return bn_experience_keywords_metrics(inputs)
	if (locale === "de") return de_experience_keywords_metrics(inputs)
	if (locale === "es") return es_experience_keywords_metrics(inputs)
	if (locale === "fr") return fr_experience_keywords_metrics(inputs)
	if (locale === "pt") return pt_experience_keywords_metrics(inputs)
	if (locale === "zh") return zh_experience_keywords_metrics(inputs)
	if (locale === "tr") return tr_experience_keywords_metrics(inputs)
	if (locale === "ru") return ru_experience_keywords_metrics(inputs)
	if (locale === "pl") return pl_experience_keywords_metrics(inputs)
	return en_experience_keywords_metrics(inputs)
});